import React from "react";
import cn from "classnames";
import { PinIcon, UserIcon } from "lucide-react";
import ChatTypeIcon from "../ChatTypeIcon";
import style from "./ChatListItem.module.scss";

const ChatListItem = ({ chat, isActive, onClick }) => {
  return (
    <div
      className={cn(style.chat_item, {
        [style.active]: isActive,
      })}
      onClick={onClick}
    >
      <div className={cn(style.chat_avatar, style[chat.type])}>
        <UserIcon color="#4A5565" />
      </div>

      <div className={style.chat_item_content}>
        <div className={style.chat_item_header}>
          <div className={style.chat_item_name_wrapper}>
            <div className={style.chat_item_icon}>
              <ChatTypeIcon type={chat.type} size={20} />
            </div>
            <span className={style.chat_item_name}>{chat.name}</span>
          </div>
          <span className={style.chat_item_time}>{chat.time}</span>
        </div>

        <div className={style.chat_item_role}>
          {chat.role}
          {chat.pinned && (
            <div className={style.pin_icon}>
              <PinIcon size={16} color="#6D7885" />
            </div>
          )}
        </div>

        <div className={style.chat_item_message_row}>
          <p className={style.chat_item_last_message}>{chat.lastMessage}</p>
          {chat.unreadCount > 0 && <div className={style.unread_badge}>{chat.unreadCount}</div>}
        </div>
      </div>
    </div>
  );
};

export default ChatListItem;
